import React from 'react';

export function AppHeader({ left, right }: { left: React.ReactNode; right?: React.ReactNode }) {
  return (
    <header className="appHeader">
      <div className="appHeaderInner">
        <div className="appHeaderLeft">{left}</div>
        <div className="appHeaderRight">{right}</div>
      </div>
    </header>
  );
}

